import { Method } from 'axios';
import { Base64 } from 'js-base64';

type IConfig = {
  consoleId: string;
  panelId: string;
  VUE_APP_MAIN_DOMAIN: string;
  ssoLoginSubDomain?: string;
  consoleLoginSubDomain?: string;
  protocol?: string;
  panelDomain?: string;
};

const domainMap = new Map([
  ['development', 'idmesh.site'],
]);

export const isIE = (() => {
  const ua = window.navigator.userAgent;
  if (ua.indexOf('MSIE ') !== -1) return true;
  if (ua.indexOf('Trident/') !== -1) return true;
  return false;
})();

const getCurrentProtocol = () => window.location.protocol.replace(/:$/, '');
const getCurrentHost = () => window.location.host;
const getCurrentHostname = () => window.location.hostname;


export const init = ({
  consoleId,
  panelId,
  VUE_APP_MAIN_DOMAIN,
  ssoLoginSubDomain,
  consoleLoginSubDomain = 'console',
}: IConfig) => {
  const currentProtocol = getCurrentProtocol();
  const currentHostname = getCurrentHostname();
  let mainDomain = currentHostname;
  globalProps.ConsoleId = consoleId;
  globalProps.MainDomain = mainDomain;
  globalProps.ConsoleDomain = getCurrentHostname();
  globalProps.CoreUri = currentProtocol + `://` + getCurrentHost();
  globalProps.PanelPrefix = ``;
  globalProps.PanelId = panelId;
  console.log('inited with', globalProps);
};

export const httpMethod = {
  POST: 'POST' as Method,
  GET: 'GET' as Method,
  DELETE: 'DELETE' as Method,
  PATCH: 'PATCH' as Method,
  PUT: 'PUT' as Method,
}

// 系统全局参数
export const globalProps = {
  // lite版属性 - 开始
  ConsoleDomain: '',
  ConsoleId: '',
  PanelId: '1',
  // lite版属性 - 结束
  // 是否使用加密的HttpHeader，本地直连测试环境中使用明文Header
  EncryptToken: process.env.NODE_ENV == 'development' ? false : true,
  // 登录用户的默认Token
  UnknownToken: Base64.encode(`{'user_type':999}`),
  // 登录用户的Token
  Token: '',
  // API请求中的HttpHeader
  TokenKey: 'X-Payload-Origin',
  // 核心回调服务(微信等社会化登录模式下需要一个固定的回调域名，若使用应用域名，会造成回调地址无法统一)
  CoreUri: '',
  // 主域名(如idmesh.cn)
  MainDomain: '',
  // API前缀
  ApiPrefix: '/api',
  // BFF前缀
  BffPrefix: '/interactive',
  // 应用面板
  PanelPrefix: '',
}

export const httpHeader = {
  applicationJson: { "Content-Type": "application/json" },
}

export const getLiteDefaultAppId = () => {
  /*if (globalProps.ConsoleDomain && window.location.host === globalProps.ConsoleDomain) {
    return globalProps.ConsoleId;
  }*/
  if (window.location.pathname.includes('/console')) {
    return globalProps.ConsoleId;
  }
  return globalProps.PanelId;
};
